/**
 * Hook that wraps useApi to automatically inject the x-act-as-prof-id header
 * for all API calls made on behalf of a reporting target.
 */

import { useCallback } from "react";
import { useApi } from "@/shared/utils/request";

export function useReportingApi(targetProfId: string | null) {
  const { makeApiRequest } = useApi();

  const makeReportingRequest = useCallback(
    (options: {
      endpoint: string;
      method: "GET" | "POST" | "PUT" | "DELETE";
      body?: unknown;
      headers?: Record<string, string>;
    }) => {
      const headers: Record<string, string> = { ...options.headers };
      if (targetProfId) {
        headers["x-act-as-prof-id"] = targetProfId;
      }
      return makeApiRequest({ ...options, headers });
    },
    [makeApiRequest, targetProfId],
  );

  return { makeReportingRequest };
}
